import { Col, Row } from "react-bootstrap";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";
import { NFLookupEmployee } from "../../../../Shared/NewForms/NFLookupEmployee";
import { useFormContext } from "react-hook-form";

const IncomingBanksLoanRepaymentByEmployeeDetail = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="senderBankAccountId" title={t("SenderBankAccount")} required />
        </Col>
        <Col sm={6}>
          <NFLookupInput fieldName="amountType" title={t("AmountType")} items={EnumHelper.GetPrincipalOperationType()} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupEmployee title={t("Employee")} fieldName="employeeId" required />
        </Col>
      </Row>
    </>
  );
};

export default IncomingBanksLoanRepaymentByEmployeeDetail;
